import gql from 'graphql-tag';

export default gql`
  mutation useUplift($use: Boolean!) {
    useUplift(use: $use) {
      order {
        status
        isUpliftSelected
        promoError {
          name
          errors
        }
      }
      errors
    }
  }
`;
